import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/players-csv/upload-players-csv/actions';

class FileUploaderButton extends Component {
    handleDropzone() {
        const {dispatch} = this.props;

        dispatch(Action.do('toggleDropzone'));
    }

    render() {
        const {playersDropzone} = this.props;

        return (
            <>
                {playersDropzone.show ? (
                    <button
                        data-tooltip-html="Hide user projections uploader"
                        type="button"
                        className="btn-text"
                        onClick={() => ::this.handleDropzone()}
                    >
                        <i className="fa fa-times-circle"></i> Hide uploader
                    </button>
                ) : (
                    <button
                        data-tooltip-html="Upload user projections"
                        type="button"
                        className="btn-text"
                        onClick={() => ::this.handleDropzone()}
                    >
                        <i className="fa fa-upload"></i> Upload csv
                    </button>
                )}
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {playersDropzone} = state;

    return {playersDropzone};
}

export default connect(mapStatesToProps)(FileUploaderButton);
